import React from 'react';
import FormInventoryConfiguration from '../../../sections/AdminDashboard/Configuration/FormInventory';

const FormInventory = () => <FormInventoryConfiguration />;

export default FormInventory;
